import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import people_icon from "../../../assets/images/slider-icon-1.png";
import click_icon from "../../../assets/images/slider-icon-2.png";
import shield_icon from "../../../assets/images/slider-icon-3.png";
import unlock_icon from "../../../assets/images/slider-icon-4.png";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Text from "../../molecules/content/Text";

function WelcomeSlider() {
  const { t } = useTranslation();
  return (
    <>
      <div className="mx-auto px-8 w-full welcome-slider flex justify-center bg-white rounded pt-2 max-[768px]:mb-8 max-[768px]:pb-4">
        <Swiper
          pagination={{
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
              return `
                            <div class="inline-flex items-center gap-1 bg-gray-200 rounded px-2 py-1 mt-10 text-sm">
                                <span class="bg-gray-200 px-1 py-1 rounded">
                                <span class="${currentClass}"></span>
                                </span>
                                <span class="text-gray-400">/</span>
                                <span class="bg-gray-200 px-1 py-1 rounded">
                                <span class="${totalClass}"></span>
                                </span>
                            </div>
                            `;
            },
          }}
          loop={true}
          navigation={{
            prevEl: ".swiper-button-prev.custom-swiper-button-prev",
            nextEl: ".swiper-button-next.custom-swiper-button-next",
          }}
          modules={[Navigation, Pagination, Scrollbar]}
          spaceBetween={50}
          slidesPerView={1}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="flex flex-col items-center text-center p-4 max-w-xl mx-auto mb-[50px] w-11/12 px-8">
              <div className="p-2 rounded-full">
                <img src={people_icon} className="size-10" />
              </div>
              <h2 className="text-lg font-[900] sm:font-semibold mt-4">
                {t("welcomeSlider.slide-1-title")}
              </h2>
              <Text variant="small" className="mt-2">
                {t("welcomeSlider.slide-1-description-1")}
              </Text>
              <Text variant="small">
                {t("welcomeSlider.slide-1-description-2")}
              </Text>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex flex-col items-center text-center p-4 max-w-xl mx-auto mb-[50px] w-11/12">
              <div className="p-2 rounded-full">
                <img src={click_icon} className="size-10 " />
              </div>
              <h2 className="text-lg font-[900] sm:font-semibold mt-4">
                {t("welcomeSlider.slide-2-title")}
              </h2>
              <Text variant="small" className="mt-2">
                {t("welcomeSlider.slide-2-description-1")}
              </Text>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex flex-col items-center text-center p-4 max-w-xl mx-auto mb-[50px] w-11/12">
              <div className="p-2 rounded-full">
                <img src={shield_icon} className="size-10 " />
              </div>
              <h2 className="text-lg font-[900] sm:font-semibold mt-4">
                {t("welcomeSlider.slide-3-title")}
              </h2>
              <Text variant="small" className="mt-2">
                {t("welcomeSlider.slide-3-description-1")}
              </Text>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex flex-col items-center text-center p-4 max-w-xl mx-auto mb-[50px] w-11/12">
              <div className="p-2 rounded-full">
                <img src={unlock_icon} className="size-10" />
              </div>
              <h2 className="text-lg font-[900] sm:font-semibold mt-4">
                {t("welcomeSlider.slide-4-title")}
              </h2>
              <Text variant="small" className="mt-2">
                {t("welcomeSlider.slide-4-description-1")}
              </Text>
            </div>
          </SwiperSlide>
          <div className="swiper-pagination"></div>
          <div className="swiper-button-prev custom-swiper-button-prev"></div>
          <div className="swiper-button-next custom-swiper-button-next"></div>
        </Swiper>
      </div>
    </>
  );
}

export default WelcomeSlider;
